import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Check } from 'lucide-react';
export function ManagementPage() {
  const services = ['Pre-opening & Concept Development', 'Culinary & Menu Engineering', 'Financial Modeling & Cost Control', 'Staff Recruitment & Training', 'Marketing & Brand Positioning', 'Daily Operational Oversight'];
  return <div className="bg-brand-beige" data-id="element-354">
      <PageHero title="Management Company" subtitle="Comprehensive operational oversight, standardizing excellence." data-id="element-355" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-356">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-357"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-358">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-359">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-360">
              <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-361">
                About JJ Group Management
              </h2>
              <div className="w-16 h-1 bg-brand-red mb-8" data-id="element-362"></div>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-8" data-id="element-363">
                Operating a successful hospitality venue requires more than just
                great food—it demands rigorous systems, exceptional training,
                and relentless financial oversight.
              </p>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-10" data-id="element-364">
                JJ Group Management offers turnkey operational solutions for
                independent owners, hotels, and institutional investors. We
                apply the same proprietary systems that made our own concepts
                successful to optimize your asset's performance.
              </p>

              <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-365">
                Core Services
              </h3>
              <ul className="space-y-4" data-id="element-366">
                {services.map((service, idx) => <li key={idx} className="flex items-center gap-3 text-brand-dark/80" data-id="element-367">
                    <Check size={18} className="text-brand-terracotta" data-id="element-368" />
                    {service}
                  </li>)}
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-369">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32b7?w=800&q=80" alt="Management team" className="w-full h-[700px] object-cover rounded-sm shadow-2xl" data-id="element-370" />
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}